<template>
    <div>
        <el-table :data="listData" border stripe style="width: 100%;border-radius: 10px;"
            :header-cell-style="{ textAlign: 'center', backgroundColor: '#b3e0ff' }"
            :cell-style="{ textAlign: 'center' }">
            <el-table-column prop="rowNumber" label="序号" width="60"></el-table-column>
            <el-table-column prop="creator" label="导出人" width="120"></el-table-column>
            <el-table-column prop="createTime" label="导出时间" width="170"></el-table-column>
            <el-table-column prop="content" label="描述"></el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-if="pageShow" v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    </div>
</template>

<script>
import {
    GetExportHistoryPageList
} from "@/api/exportHistoryApi.js";
export default {
    data() {
        return {
            pageShow: true,
            loading: false, // 显示加载
            listData: [],
            formInline: {
                keyId: "",
                pageIndex: 1,
                pageSize: 10,
            },
            // 分页参数
            pageparm: {
                pageIndex: 1,
                pageSize: 10,
                total: 0,
            },
        };
    },
    // 注册组件
    components: {

    },
    created() {

    },
    computed: {},
    methods: {
        showExportHistory(val) {
            this.formInline.keyId = val;
            this.getListData();
        },
        // 获取列表
        getListData() {
            this.loading = true;
            GetExportHistoryPageList(this.formInline)
                .then((res) => {
                    if (res.code == 1) {
                        this.loading = false;
                        this.listData = res.data;
                    } else {
                        this.$message({
                            type: "info",
                            message: res.msg,
                        });
                    }
                })
                .catch((err) => {
                    this.loading = false;
                    this.$message.error("数据加载失败，请稍后再试！");
                }).finally(() => {
                    this.loading = false;
                });
        },
        // 分页插件事件
        callFather(parm) {
            if (parm.currentPage == undefined) {
                this.formInline.pageIndex = 1;
            } else {
                this.formInline.pageIndex = parm.currentPage;
            }
            this.formInline.pageSize = parm.pageSize;
            this.getListData();
        },
        // 搜索事件
        search() {
            this.formInline.pageIndex = 1;
            this.pageShow = false;
            this.$nextTick(() => {
                this.pageShow = true;
            });
            this.getListData();
        },
    },
};
</script>

<style scoped></style>